import { Transformer as HashTransformer } from 'hooks/use-hash';
import { GroupBy } from '../types';

export const toGroupBy = (value: string): GroupBy | null => {
  switch (value) {
    case 'projects':
      return GroupBy.Projects;
    case 'users':
      return GroupBy.Users;
    default:
      return null;
  }
};

export const groupByTransformer: HashTransformer<GroupBy> = {
  from: (parsed) => {
    const group = parsed.groupBy
      ? typeof parsed.groupBy === 'string'
        ? toGroupBy(parsed.groupBy)
        : toGroupBy(parsed.groupBy[0])
      : null;

    return group ?? GroupBy.Users;
  },
  to: (value: GroupBy) => {
    return { groupBy: value.toString() };
  },
};
